import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class PrizeContainer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2;

        let labelY: number;

        if (GameVars.aspectRatio < 1.65) {

            this.scaleX = .9;
            this.scaleY = .9 * GameVars.scaleY;
            labelY = 430;

        } else {
            this.scaleY = GameVars.scaleY;
            labelY = 550;
        }

        let pItemY: number;

        if ((GameVars.spinResponse.prize.is_complex && !GameVars.spinResponse.prize.is_full_complex ) || GameVars.spinResponse.prize.is_won ) {

            const balloonContainer = new Phaser.GameObjects.Container(this.scene, 0, -310);
            balloonContainer.alpha = 0;
            this.add(balloonContainer);

            const balloonImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "balloon");
            balloonContainer.add(balloonImage);

            let labelStr: string;
           
            if (GameVars.spinResponse.prize.is_complex && !GameVars.spinResponse.prize.is_full_complex) {
                labelStr = GameVars.gameInfo.won_prize.another_part_text;
            } else {
                labelStr = GameVars.gameInfo.won_prize.won_prize_text;
            }

            const balloonLabel = new Phaser.GameObjects.Text(this.scene, 0, -25, labelStr, {fontFamily: "Helvetica", fontSize: "46px", color: "#000000", align: "center", wordWrap: { width: 800, useAdvancedWrap: true }});
            balloonLabel.setOrigin(.5);
            balloonContainer.add(balloonLabel);
           
            this.scene.add.tween({
                targets: balloonContainer,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.InOut,
                duration: 350,
                delay: 800
            });

            pItemY = 120;
        } else {
            pItemY = 0;
        }

        let itemImg: Phaser.GameObjects.Image;

        if (GameVars.spinResponse.prize.image) {

            itemImg = new Phaser.GameObjects.Image(this.scene, 0, pItemY - 95, "prize-image-" + GameVars.spinResponse.prize.id);

            let scale: number;

            if (GameVars.aspectRatio < 1.65) {
                scale = 525 / itemImg.width;
            } else {
                scale = 600 / itemImg.width;
            }
           
            itemImg.setScale(scale);

        } else {
            itemImg = new Phaser.GameObjects.Image(this.scene, 0, pItemY - 95, "texture_atlas_1", "box_big");
        }
 
        itemImg.alpha = 0;
        this.add(itemImg);

        this.scene.add.tween({
            targets: itemImg,
            alpha: 1,
            y: pItemY,
            scaleX: itemImg.scale * 1.15,
            scaleY: itemImg.scale * 1.15,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 650,
            delay: 200
        });

        const description = GameVars.spinResponse.prize.name;
        
        let fontSize: string;
        
        if (description.length < 40) {
            fontSize = "90px";
        } else if (description.length < 60) {
            fontSize = "80px";
        } else if(description.length < 100) {
            fontSize = "62px";
        } else if(description.length < 140){
            fontSize = "52px";
        } else {
            fontSize = "40px";
        }

        const descriptionLabel = new Phaser.GameObjects.Text(this.scene, 0, labelY, description, { 
            fontFamily: "FuturaPTBook", 
            fontSize: fontSize, 
            color: "#FFE0B1", 
            align: "center",
            wordWrap: {width: 1050, useAdvancedWrap: true },
        });
        descriptionLabel.setOrigin(.5)
        descriptionLabel.alpha = 0;
        this.add(descriptionLabel);

        this.scene.add.tween({
            targets: descriptionLabel,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 750,
            delay: 700
        });

        this.scene.sound.playAudioSprite("audio-sprite", "prize");
    }
}
